module.exports = __webpack_public_path__ + "img/1575873222.fe8ba8ea.jpg";